import React from "react";
import { Typography } from "@material-ui/core";

export const NotFound: React.FC = () => {
  return (
      <Typography variant="h4" component="h1" gutterBottom>
        404 - Page not found
      </Typography>
  );
};
